<template>

<div>
<ContentHeader title="Denetleme Soruları"  :show_button="false" ></ContentHeader>


<template v-if="section">
	

<div class="sections mt-4">


<div class="grid">
<div class="col-10">


<h3 class="text-primary" >{{getTheTranslation(section.section,"translation")}}</h3>  








</div>
<div class="col-2 mt-3"><Button label="Üst Bölüm" icon="pi pi-arrow-left" v-if="$store.state.audit.display=='sections'" class="w-full p-button-help p-button-outlined  p-button-sm" @click="gotoParentSection" ></Button></div>
<!--<AuditViewSwitch></AuditViewSwitch>-->




<div class="col-12">
<template v-if="section.section.translations.length">
  <template v-for="translation in section.section.translations">
  <template v-if="$store.state.auth.user.preflang_id == translation.language_id">
    <h5 class="pb-3" v-if="translation.description">{{translation.description}}</h5>
  </template>  
</template>
</template>
</div>


</div>






<template  v-if="section.childsections.length">
<AuditSectionSelector v-for="item in section.childsections" :data="item"></AuditSectionSelector>
</template>


</div> 




 <template v-if="section.inputfields.length">
 <h3 class="text-primary">{{$store.state.languages.lang_phrases.sorular}}</h3>
 <CustomAuditInputfield v-for="item in section.inputfields" :data="item"></CustomAuditInputfield>
 </template>



</template>



</div>
</template>

<script>
export default {

  name: 'AuditQuestionListSection',

  data () {
    return {
    	section:null,
    }
  },
  mounted()
  {
  	this.getData()
  },
  computed:{
  	inputfields_updating()
  	{
  		return this.$store.state.evaluation.inputfields_updating
  	}
  },
  watch:{
  	inputfields_updating(newVal)
  	{
  		if(!newVal)
  		{
  			console.log("inputfields_updating")
  			this.getData()
  		}
  	}
  },
  methods:{
  	async getData()
  	{
  		console.log("AuditQuestionListSection")
  		this.section = await this.arrangeAuditSectionInputfields(this.$route.params.section_id)
  		
  		console.log(this.section)
  		

  	},
  	gotoParentSection()
  	{
  		console.log(this.section);
  		//return false
  		if(this.section.section.parent_id===0)
  		{
  			this.$router.push({ name: 'AuditQuestionList' })
  		}
  		else
  		{
  			this.$router.push({ name: 'AuditQuestionListSection', params: { section_id:this.section.section.parent_id } })
  		}
  		
  	},
  }
}
</script>

<style lang="css" scoped>
</style>